import React from "react"
import Linked from "../elements/Linked"
import RichTextOptions from "../rich-text/RichTextOptions"
import { renderRichText } from "gatsby-source-contentful/rich-text"

export default function CareersJob({ header, text }) {
  return (
    <div className="space-y-4">
      <h3 className="text-lg md:text-2xl font-bold font-sans">{header}</h3>
      {renderRichText(text, RichTextOptions)}
      <div className="mt-8">
        <Linked
          className={`text-secondary`}
          linkTo={`mailto:recruitment@katchthis.com?subject=${header} Application`}
        >
          Quick Apply
        </Linked>
      </div>
    </div>
  )
}
